import { useContext } from 'react';
import download from 'downloadjs';
import ToastContext from 'src/store/toast-context';
import useAdminAPI from 'src/services/useAdminAPI';

const getFilingReviewPdf = async (api, handleError, user) => {
  try {
    const { data } = await api.get('/review/download', { params: user });
    download(data, 'review.pdf');
  } catch (err) {
    console.error(err);
    handleError(err);
  }
};

const getFilingAssetsPDF = async (api, handleError, user) => {
  try {
    const { data } = await api.get('/review/download/assets', { params: user });
    download(data, 'review.pdf');
  } catch (err) {
    console.error(err);
    handleError(err);
  }
};

export const useFilingReview = () => {
  const { handleError } = useContext(ToastContext);
  const api = useAdminAPI();
  return {
    downloadReview: async (user, setLoadedPDF) => {
      setLoadedPDF(false);
      user ? await getFilingReviewPdf(api, handleError, user) : () => {};
      setLoadedPDF(true);
    },
    downloadAssets: async (user, setLoadedPDF) => {
      setLoadedPDF(false);
      user ? await getFilingAssetsPDF(api, handleError, user) : () => {};
      setLoadedPDF(true);
    },
  };
};
